<script setup lang="ts">
  const { status } = useAuth();
  const loading = ref(false);
  const csrfToken = ref('');

  watchEffect(() => {
    if (status.value === 'authenticated') {
      navigateTo('/dashboard', { replace: true });
    }
  });

  onMounted(async () => {
    const data = await $fetch<{ csrfToken: string }>('/api/auth/csrf');
    csrfToken.value = data.csrfToken;
  });
</script>
<template>
  <div class="flex flex-col items-center justify-center h-screen">
    <div class="w-full max-w-md p-8 space-y-6 bg-white dark:bg-gray-900 rounded-lg shadow-xl border border-gray-100 dark:border-gray-800">
      <div class="text-center space-y-2">
        <h1 class="text-3xl font-bold tracking-tight">Get Started</h1>
        <p class="text-sm text-gray-500 dark:text-gray-400">Create your account via Zitadel</p>
      </div>
      <!-- Native form POST: browser follows OAuth redirects as page navigations, bypassing CORS -->
      <form method="post" action="/api/auth/signin/zitadel">
        <input type="hidden" name="csrfToken" :value="csrfToken" />
        <UButton
          type="submit"
          :disabled="!csrfToken"
          size="lg"
          color="primary"
          class="w-full flex items-center justify-center font-medium tracking-wide">
          Sign up with Zitadel
        </UButton>
      </form>
      <p class="mt-4 text-xs text-center text-gray-500">
        By proceeding, I agree to the
        <NuxtLink to="/privacy">Privacy Statement</NuxtLink> and
        <NuxtLink to="/terms">Terms of Service</NuxtLink>
      </p>
    </div>
  </div>
</template>
